/*
* Query used to fetch user info by user name
* Below are the list of services that it talks to:
    * AWSSCMUserManagementService
*/
import { gql } from '@apollo/client';

import { processResponse } from "./helper";

export const getUserByUsernameQuery = gql `
query getUserByUsername(
    $username: String!
) {
    getUserByUsername(
        username: $username
    ) {
      user {
        userId
        givenName
        familyName
        vendorIds
        applications
        onboardStatus
      }
    }
}
`;

export default function getUserByUsername(this: any, request: any) {
    return processResponse(this.query({
        query: getUserByUsernameQuery,
        variables: request,
    }), 'getUserByUsername');
}
